// More projections can be added here
export const PROJECTION_REF_SYSTEMS = {
  EPSG_5514: "EPSG:5514",
};
